import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'

import type { LessonClass } from './LessonClass'

type K = LessonClass['id']

/***
 * @see LessonClass
 ***/
export class LessonClassColl {
  private coll: ExtendedMap<LessonClass['id'], LessonClass>

  constructor(lessonClasses: LessonClass[]) {
    makeAutoObservable(this)

    this.coll = ExtendedMap.fromArr(lessonClasses, 'id')
  }

  get toArr() {
    return [...this.coll.values()]
  }

  get isEmpty() {
    return this.coll.isEmpty
  }

  get isNotEmpty() {
    return this.coll.isNotEmpty
  }

  setClass(lessonClass: LessonClass) {
    this.coll.set(lessonClass.id, lessonClass)
  }

  fromArr(lessonClasses: LessonClass[]) {
    this.coll = ExtendedMap.fromArr(lessonClasses, 'id')
  }

  getClass(id: K) {
    return this.coll.get(id)
  }

  adds(lessonClassColl: LessonClassColl) {
    this.coll.adds(lessonClassColl.coll.entries())
  }
}
